<template>
    <section class="sponsors-list" v-if="sponsors && sponsors.length">
        <div class="container">
            <div class="header">
                <h2>Thank you to our OHC 2026 sponsors</h2>
            </div>
            <ul>
                <template v-for="(item, index) in sponsors">
                    <li class="sponsor" v-if="item.fields['Sponsor Website'] && item.fields['Sponsor Logo']" :key="'sponsor' + index">
                        <a v-if="item.internal" :href="link.href" @click.native="sendToExternal">
                            <mess-image loading="lazy" :image="item.fields['Sponsor Logo'][0]" :alt="item.fields['Sponsor Name']" :width="150" />
                        </a>
                        <a v-else class="item-link" :href="item.fields['Sponsor Website']" :alt="item.alt" target="_blank">
                            <mess-image loading="lazy" :image="item.fields['Sponsor Logo'][0]" :alt="item.fields['Sponsor Name']" :width="150" />
                        </a>
                    </li>
                </template>
            </ul>
        </div>
    </section>
</template>

<script setup>
    import { useSponsorsStore } from '@/stores/sponsors';
    const { sponsorsData } = storeToRefs(useSponsorsStore());

    const route = useRoute();
    const isFramed = ref(route.path.includes('iframe'));
    const items = computed(() => sponsorsData.value?.records);

    const sponsors = computed(() => {
        if (items.value && items.value.length) {
            return items.value.filter((item) => {
                return item.fields['Sponsor Website'] && item.fields['Sponsor Name'];
            });
        }
        return [];
    });

    const sendToExternal = (ev) => {
        if (ev.currentTarget && ev.currentTarget.tagName === 'A') {
            const href = ev.currentTarget.getAttribute('href');
            if (isFramed.value) {
                window.parent.postMessage({ type: 'navigateTo', href: href }, '*');
                ev.preventDefault();
                return false;
            }
        }
        return true;
    };
</script>

<style lang="scss" scoped>
    .sponsors-list {
        padding: 55px 0 20px;

        h2 {
            font-family: $title;
            font-size: 18px;
            font-weight: 700;
            line-height: 1.1em;
            letter-spacing: 0.18px;
            text-transform: uppercase;
        }

        .header {
            margin-bottom: 30px;
        }

        ul {
            display: flex;
            flex-flow: row wrap;
            justify-content: center;
            .sponsor {
                width: calc(33% - 30px);
                margin: 0 15px;
                display: flex;
                align-items: center;
                justify-content: center;

                @media (min-width: $tablet) {
                    width: 25%;
                    margin: 0;
                }

                a {
                    display: inline-block;
                    margin: 0 auto;
                    font-weight: $bold;
                }

                img {
                    margin: 0 auto;
                    display: block;
                    width: 100%;
                    max-height: 55px;
                    object-fit: contain;

                    @media (min-width: $tablet) {
                        margin: 15px auto;
                    }
                }

                &:first-child {
                    width: calc(100% - 30px);
                    img {
                        max-width: 215px;
                        max-height: 82px;

                        @media (min-width: $tablet) {
                            max-height: 90px;
                            max-width: 300px;
                        }
                    }
                }

                &:not(:first-child) {
                    margin-top: 33px;
                    img {
                        max-width: 90px;

                        @media (min-width: $tablet) {
                            max-width: 150px;
                            max-height: 70px;
                        }
                    }
                }
            }
        }
    }
</style>
